<template>
  <div class="mdl-dialog modal-container center">
    <div class="mdl-dialog__content">
      <i class="material-icons big-icon">alarm_off</i>

      <h1 class="headline">Revocation deadline has passed</h1>

      <p>You are no longer able to revoke your submissions.</p>

      <p>
        The deadline to revoke submissions was
        <b>{{ deadlineFormatted }}</b>
        .
      </p>

      <p>No further actions can be taken.</p>
    </div>
    <div class="mdl-dialog__actions">
      <button
        type="button"
        @click="$emit('close-modal')"
        class="mdl-button mdl-js-button mdl-button--raised"
      >
        <i class="material-icons">close</i>
        Close
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    deadlineFormatted: {
      type: String,
      required: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Home/RevokeModal/RevokeModalDeadline.vue